// JQ needs to be replaced with JS
const handleSwipeEvent = (e, slickInstance, isAnimating) => {
  const deltaX = e.deltaX;
  const deltaY = e.deltaY;
  const absDeltaX = Math.abs(deltaX);
  const absDeltaY = Math.abs(deltaY);

  if (absDeltaX > absDeltaY) {
    e.preventDefault();

    if (!isAnimating) {
      const direction = deltaX;
      direction > 0 ? slickInstance.slick('slickNext') : slickInstance.slick('slickPrev');
    }
  }
};

const attachSwipeEvents = (selector) => {
  $(selector).each(function () {
    const $carousel = $(this);
    let isAnimating = false;
    let isScrolling = false;

    $carousel.on('beforeChange', () => { isAnimating = true; });
    $carousel.on('afterChange', () => { 
      isAnimating = false;
      isScrolling = false;
    });

    $carousel.on('wheel', (e) => {
      if (!isScrolling) {
        handleSwipeEvent(e.originalEvent, $carousel, isAnimating);
        isScrolling = true;
      }
    });
  });
};

export { attachSwipeEvents };
